module.exports = __webpack_public_path__ + "img/keep_remove.941efe9a.png";